import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function MiningLifecycleVisual({ title, takeaway, caption, data = {} }) {
  const stages = data.stages || ["Exploration", "Discovery", "Resource", "Development", "Construction", "Production"];
  const evidence = data.evidence || ["Geology", "Drilling Results", "Resource Quality", "Studies & Economics", "Funding Execution", "Operations & Cash Flow"];
  const leftNote = data.leftNote || "Higher uncertainty";
  const rightNote = data.rightNote || "More operating evidence";
  const startX = 72;
  const step = 122;

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="large">
      <svg viewBox="0 0 820 330" role="img" aria-label={`Mining lifecycle progression from ${stages.join(" to ")}, with evidence shifting from geology and drilling results toward studies, funding execution, operations and cash flow.`}>
        <line x1={startX} y1="104" x2={startX + step * (stages.length - 1)} y2="104" stroke={p.line} strokeWidth="3" />
        {stages.map((stage, index) => {
          const x = startX + index * step;
          const active = index === 0 || index === stages.length - 1;
          return (
            <g key={stage}>
              <circle cx={x} cy="104" r="17" fill={active ? p.goldWash : "#fff"} stroke={active ? p.gold : p.line} strokeWidth="2" />
              <circle cx={x} cy="104" r="5" fill={active ? p.gold : p.muted} />
              <text x={x} y="148" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.ink}>{stage}</text>
              <line x1={x} y1="160" x2={x} y2="194" stroke={p.softLine} strokeWidth="1.5" />
              <foreignObject x={x - 48} y="204" width="96" height="50">
                <div xmlns="http://www.w3.org/1999/xhtml" style={{ fontSize: 12, lineHeight: 1.25, color: p.ink, textAlign: "center", fontWeight: 800 }}>
                  {evidence[index]}
                </div>
              </foreignObject>
            </g>
          );
        })}
        <path d={`M${startX} 52 H${startX + step * (stages.length - 1)}`} stroke={p.gold} strokeWidth="2" />
        <path d={`M${startX + step * (stages.length - 1)} 52 l-10 -7 v14 z`} fill={p.gold} />
        <text x={startX} y="36" textAnchor="start" fontSize="13" fontWeight="850" fill={p.muted}>{leftNote}</text>
        <text x={startX + step * (stages.length - 1)} y="36" textAnchor="end" fontSize="13" fontWeight="850" fill={p.muted}>{rightNote}</text>
      </svg>
    </LearnVisualFrame>
  );
}
